export const agenda = {
  agendaDuration: 'trvání',
  agendaCurtainCopy: 'Zkopírovat odkaz',
  agendaCurtainFlag: 'Označit obsah',
  agendaCurtainFlagSent: 'Obsah nahlášen',
  agendaLinkCopied: 'Odkaz zkopírován!',
  agendaStartsAt: 'Začíná v ',
  agendaEndsAt: 'Končí v ',
  agendaSpeakers: 'Řečníci',
  agendaSeeAllSpeakers: 'Zobrazit vše',
  agendaAddToSchedule: 'Přidat do mého plánu',
  agendaRemoveFromSchedule: 'Odebrat z mého plánu',
  agendaAddedToSchedule: 'Přidáno do mého plánu!',
  agendaRemovedFromSchedule: 'Odebráno z mého plánu!',
  agendaCalendar: 'Kalendář',
  agendaAddToCalendar: 'Přidat do systémového kalendáře?',
  agendaCalendarSkip: 'Přeskočit',
  agendaCalendarAdd: 'Přidat',
  agendaNow: 'NYNÍ',
  agendaModerators: 'Moderátoři',

  QnATitle: 'Otázky a odpovědi',
  askASpeaker: 'Zeptejte se řečníka',
  askAQuestion: 'Položit otázku',
  askQuestionPlaceholder: 'Zadejte svou otázku zde',
  cancel: 'Zrušit',
  ask: 'Zeptat se',
  deleteConfirmation: 'Chcete tuto otázku smazat?',
  questionDeleted: 'Otázka byla úspěšně smazána!',
  rateSession: 'Ohodnoťte tuto relaci'
}
